<div id="visualizar-boleta-consorcio" class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">
            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/consorcio/lista-boleta-consorcio'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div
                    fxLayout="column"
                    fxLayoutAlign="start start"
                    [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }"
                >
                    <div class="h2">Visualizar Boleta</div>
                </div>
            </div>
            <!-- / APP TITLE -->
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div id="about" class="p-24" fxLayout="row wrap">
                <div class="about-content" fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="65">
                    <!-- dados da boleta -->
                    <div class="profile-box info-box general" fxLayout="column">
                        <header class="accent">
                            <div class="title">Dados da Boleta</div>
                        </header>

                        <div class="content">
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Cliente</div>
                                    <div class="info">{{ model.cliente?.nome }}</div>
                                </div>
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Status</div>
                                    <div class="info">{{ model.status?.nome }}</div>
                                </div>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Parceiro</div>
                                    <div class="info">{{ model.parceiro_consorcio?.nome }}</div>
                                </div>
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Tipo Operação</div>
                                    <div class="info">{{ model.tipo_consorcio?.nome }}</div>
                                </div>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Quantidade de cartas</div>
                                    <div class="info">{{ model.qtd_cartas }}</div>
                                </div>
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Valor total de cartas</div>
                                    <div class="info">R$ {{ model.valor | number : "1.2-2" }}</div>
                                </div>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Lance Recorrente?</div>
                                    <div class="info">
                                        {{ model.is_recorrente != null ? (model.is_recorrente ? "SIM" : "NÃO") : "" }}
                                    </div>
                                </div>
                                <div class="info-line" floatLabel="always" fxFlex="48">
                                    <div class="title">Lance Livre/Fixo</div>
                                    <div class="info">
                                        {{
                                            model.is_fixo_livre != null
                                                ? model.is_fixo_livre == "FIXO"
                                                    ? "Fixo"
                                                    : "Livre"
                                                : ""
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <div class="info-line" floatLabel="always" fxFlex="100">
                                    <div class="title">Observação</div>
                                    <div class="info">{{ model.observacao }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End dados da boleta -->

                    <!--Carteira consórcio-->
                    <div class="profile-box info-box general" fxLayout="column">
                        <header class="accent">
                            <div class="title">Dados das Cartas</div>
                        </header>

                        <div class="content">
                            <mat-accordion>
                                <mat-expansion-panel *ngFor="let item of model.cartas">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Carta N {{ item.id }} R$ ( R${{ item.valor_carta | number : "1.2-2" }})
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            Cliquei aqui para abrir detalhes da carta
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div class="content">
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Grupo</div>
                                                <div class="info">{{ item.grupo }}</div>
                                            </div>
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Cota</div>
                                                <div class="info">{{ item.cota }}</div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Prazo Grupo</div>
                                                <div class="info">{{ item.prazo_grupo }}</div>
                                            </div>
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Taxa de Administrativa Grupo</div>
                                                <div class="info">
                                                    R${{ item.taxa_administrativa_grupo | number : "1.2-2" }}
                                                </div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Data de Fechamento</div>
                                                <div class="info">{{ item.data_fechamento | date : "dd/MM/yyyy" }}</div>
                                            </div>
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Tabela de Fechamento</div>
                                                <div class="info">
                                                    {{ item.fechamento ? item.fechamento.nome : "" }}
                                                </div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <div class="info-line" loatLabel="always" fxFlex="48">
                                                <div class="title">Desconto %</div>
                                                <div class="info">{{ item.desconto | number : "1.2-2" }}%</div>
                                            </div>
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Data de Pagamento</div>
                                                <div class="info">{{ item.data_pagamento | date : "dd/MM/yyyy" }}</div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Valor da Carta</div>
                                                <div class="info">R${{ item.valor_carta | number : "1.2-2" }}</div>
                                            </div>
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Status da Carta</div>
                                                <div class="info">{{ item.status ? item.status.nome : "" }}</div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="flex-end" *ngIf="item.data_contemplacao">
                                            <div class="info-line" floatLabel="always" fxFlex="48">
                                                <div class="title">Data de Contemplação</div>
                                                <div class="info">
                                                    {{ item.data_contemplacao | date : "dd/MM/yyyy" }}
                                                </div>
                                            </div>
                                        </div>
                                        <div fxLayout="column" fxLayoutAlign="space-between" class="mt-16">
                                            <table
                                                mat-table
                                                [dataSource]="item.lances"
                                                class="mat-elevation-z8"
                                                fxFlex="100"
                                            >
                                                <!-- Definindo as colunas corretamente -->
                                                <ng-container matColumnDef="tipo_lance">
                                                    <th mat-header-cell *matHeaderCellDef>Tipo Lance</th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{
                                                            element.tipo_lance?.nome
                                                                ? element.tipo_lance?.nome
                                                                : "Campo Vazio"
                                                        }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="tipo_valor">
                                                    <th mat-header-cell *matHeaderCellDef>Tipo de Valor</th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{
                                                            element.tipo_lance?.tipo_valor == "percent"
                                                                ? "Percentual (%)"
                                                                : "Valor (R$)"
                                                        }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="valor_lance">
                                                    <th mat-header-cell *matHeaderCellDef>Valor Lance</th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{ element.tipo_lance?.tipo_valor == "percent" ? "% " : "R$ " }}
                                                        {{
                                                            element.valor_lance
                                                                ? element.valor_lance
                                                                : (0.0 | number : "1.2-2")
                                                        }}
                                                    </td>
                                                </ng-container>

                                                <!-- Renderizando cabeçalhos e linhas de dados -->
                                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                            </table>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </div>
                    <!--Carteira consórcio-->
                </div>

                <!-- Histórico da boleta: uma fotografia por salvamento (PROSP-662) -->
                <div class="about-sidebar" fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="35">
                    <div class="profile-box friends" fxLayout="column">
                        <header class="accent" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="title">Histórico</div>
                        </header>

                        <div class="content">
                            <div
                                class="group"
                                *ngFor="let historico of model.historico"
                                data-test="historico-linha"
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <div fxLayout="row" fxLayoutAlign="space-between start center">
                                    <div class="logo">
                                        <img class="avatar" [src]="historico.responsavel.url_avatar" />
                                    </div>
                                    <div>
                                        <div class="members">
                                            Data Atualização: {{ historico.data_alteracao | date : "dd/MM/yyyy HH:mm" }}
                                        </div>
                                        <!--
                                            PROSP-662: a coluna de responsável tem duas semânticas e a
                                            era se distingue pela convenção `valor` nulo — linha anterior
                                            à migração (ou backend ainda não publicado) traz o DONO da
                                            boleta; linha nova traz quem realizou a alteração.
                                        -->
                                        <div class="name" *ngIf="historico.valor == null" data-test="historico-responsavel-legado">
                                            Proprietário da boleta: {{ historico.responsavel.name }}
                                        </div>
                                        <div class="name" *ngIf="historico.valor != null" data-test="historico-responsavel-alteracao">
                                            Responsável pela alteração: {{ historico.responsavel.name }}
                                        </div>
                                        <div class="category">Status: {{ historico.status.nome }}</div>
                                        <!--
                                            PROSP-662: as duas guardas abaixo são contrato, não enfeite.
                                            Linha anterior à migração traz `valor` nulo — e o backend
                                            ainda não publicado traz indefinido. `!= null` cobre os dois;
                                            sem ela a tela mostraria "Valor: R$" vazio.
                                        -->
                                        <div class="category" *ngIf="historico.valor != null">
                                            Valor: R$ {{ historico.valor | number : "1.2-2" }}
                                        </div>
                                        <div class="category" *ngIf="historico.observacao">
                                            Obs: {{ historico.observacao }}
                                        </div>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
